import React, {useEffect, useState} from 'react';
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";
import DynaSelectBox from "../../../DynaView/DynaSelectBox";
import TableWithPagination from "./TableWithPagination";
import Loader from "../../../../Loader";
import DynaInput from "../../../DynaView/DynaInput";

const LeadsList = ({
                     initialData,
                     setInitialData,
                     setLeadIdFromList,
                     setActiveTab,
                     reRender,
                     setReRender,
                     leadIdFromList
                   }) => {

  const [isLoad, setIsLoad] = useState(false);
  const [filterValue, setFilterValue] = useState({
    group: "",
    province: "",
    city: "",
    column: "",
    value: "",
    lastCall: "",
    lastStatus: ""
  })
  const [cities, setCities] = useState([]);

  const getInitialData = async (mode) => {

    const formData = new FormData();

    if (mode === "delete") {
      formData.append("group", "");
      formData.append("province", "");
      formData.append("city", "");
      formData.append("column", "");
      formData.append("value", "");
      formData.append("lastCall", "")
      formData.append("lastStatus", "")
      setFilterValue({
        group: "",
        province: "",
        city: "",
        column: "",
        value: "",
        lastCall: "",
        lastStatus: ""
      })
    } else {
      formData.append("group", filterValue?.group);
      formData.append("province", filterValue?.province);
      formData.append("city", filterValue?.city);
      formData.append("column", filterValue?.column);
      formData.append("value", filterValue?.value);
      formData.append("lastCall", filterValue?.lastCall)
      formData.append("lastStatus", filterValue?.lastStatus)
    }

    const response = await _axios.post(prefixUrl() + "/sadenMarketingCRM/?request=tableData", formData)
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    if (reRender !== 0) {
      void getInitialData()
    }
  }, [reRender]);

  useEffect(() => {
    if (Object.keys(initialData).length === 0) {
      void getInitialData()
    } else {
      setIsLoad(true)
    }
  }, []);

  useEffect(() => {
    if (filterValue?.province === "") {
      setFilterValue({...filterValue, city: ""})
    } else {
      const filtered = initialData?.selectBoxValues?.province.filter((item) => {
        return item?.value === filterValue?.province
      })
      setCities(filtered[0].cities)
      setFilterValue({...filterValue, city: ""})
    }
  }, [filterValue?.province]);

  useEffect(() => {
    if (leadIdFromList) {
      const timer = setTimeout(() => {
        setLeadIdFromList("")
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      {isLoad ?
        <div className={"LeadsList"}>
          <div className={"box-filter"}>
            <DynaSelectBox options={initialData?.selectBoxValues?.group}
                           hasFilter={true}
                           label={"انتخاب گروه"}
                           className={"solid-dyna-input"}
                           value={filterValue?.group}
                           onChange={(data) => setFilterValue({
                             ...filterValue,
                             group: data.value,
                           })}
            />
            <DynaSelectBox options={initialData?.selectBoxValues?.province}
                           hasFilter={true}
                           label={"استان"}
                           className={"solid-dyna-input"}
                           value={filterValue?.province}
                           onChange={(data) => setFilterValue({
                             ...filterValue,
                             province: data.value,
                           })}
            />
            <DynaSelectBox options={cities}
                           hasFilter={true}
                           label={"شهر"}
                           className={"solid-dyna-input"}
                           value={filterValue?.city}
                           onChange={(data) => setFilterValue({
                             ...filterValue,
                             city: data.value,
                           })}
            />
            <DynaSelectBox options={initialData?.selectBoxValues?.lastCallOptions}
                           hasFilter={true}
                           label={"نتیجه تماس"}
                           className={"solid-dyna-input"}
                           value={filterValue?.lastCall}
                           onChange={(data) => setFilterValue({
                             ...filterValue,
                             lastCall: data.value,
                           })}
            />
            <DynaSelectBox options={initialData?.selectBoxValues?.lastStatusOptions}
                           hasFilter={true}
                           label={"آخرین وضعیت"}
                           className={"solid-dyna-input"}
                           value={filterValue?.lastStatus}
                           onChange={(data) => setFilterValue({
                             ...filterValue,
                             lastStatus: data.value,
                           })}
            />
            <DynaSelectBox options={initialData?.selectBoxValues?.optionalColumns}
                           hasFilter={true}
                           label={"سایر جستجو"}
                           className={"solid-dyna-input"}
                           value={filterValue?.column}
                           onChange={(data) => setFilterValue({
                             ...filterValue,
                             column: data.value,
                           })}
            />
            <DynaInput label={"مقدار"}
                       name={"value"}
                       className={"solid-dyna-input"}
                       placeholder={"مقدار"}
                       value={filterValue?.value}
                       type={"text"}
                       setDataFromComponent={(data) => {
                         setFilterValue({...filterValue, ...data})
                       }}
            />

            <div className={"search-button"}>
              <button onClick={getInitialData}>جستجو</button>
              <button onClick={() => getInitialData("delete")}>حذف فیلتر</button>
            </div>
          </div>
          <TableWithPagination columns={initialData?.tableData?.columns}
                               data={initialData?.tableData?.data}
                               setActiveTab={setActiveTab}
                               setReRender={setReRender}
                               hasCloseIcon={true}
                               closeFunction={"LeadsList"}
                               focusRowId={leadIdFromList}
                               setLeadIdFromList={setLeadIdFromList}/>
        </div> : <Loader/>
      }
    </>
  );
};

export default LeadsList;